import { render, staticRenderFns } from "./CaseGuaranteedBoxDetails.vue?vue&type=template&id=fae14116&scoped=true&"
import script from "./CaseGuaranteedBoxDetails.vue?vue&type=script&lang=js&"
export * from "./CaseGuaranteedBoxDetails.vue?vue&type=script&lang=js&"
import style0 from "./CaseGuaranteedBoxDetails.vue?vue&type=style&index=0&id=fae14116&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae14116",
  null
  
)

export default component.exports